export default {
  unavailable: 'Dieser Block ist nicht mehr verfügbar und wird im Bericht ausgelassen.',
  onlyIncludedFor: 'Nur enthalten beim Export für: {scopes}',
  configuration: 'Konfiguration',
  template: 'Vorlage',
  replaced: 'Ersetzt',
  default: 'Standard',
  variables: 'Variablen',
};
